import { useState } from "react";

import { useOption } from "#/store/options/tradePanel/option";
import { useOptionTradeType } from "#/store/options/tradePanel/optionTradeType";

export type BookTradeTab = "book" | "trades";

export const useBookAndTradesController = () => {
  const { option } = useOption();
  const { optionTradeType } = useOptionTradeType();

  const isRFQ = optionTradeType === "rfq";

  const [tab, setTab] = useState<BookTradeTab>("book");

  const handleToggleTab = (id: BookTradeTab) => {
    setTab(id);
  };

  const isOptionLoading =
    (!option?.bids && !option?.asks) || typeof option?.markPrice !== "number";

  return {
    tab,
    isRFQ,
    orders: {
      buys: option?.bids,
      sells: option?.asks,
    },
    isLoading: isOptionLoading,
    handleToggleTab,
  };
};
